import {useContext} from 'react';
import {ToastContext} from '../ToastContext';

export const useShowToast = () => useContext(ToastContext);
